<template>
  <span>
    <template v-if="!noLabel"
      ><slot name="label"
        >{{
          $t("people:ShoppingBasket.ShoppingBasketTab.Competition.label")
        }}:</slot
      >
    </template>
    {{ competition.code }}<template v-if="competition.name"> | </template
    >{{ competition.name }}
  </span>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
export default defineComponent({
  name: "AppShowCompetitionCodeAndName",
  props: {
    competition: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    }
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        id
        name
        code
      }
    `
  }
});
</script>
